import type { ResponseDto } from '@app/api/dtos'
import type { CatalogProductDto } from '@app/api/routes/catalog/dtos'
import type { CatalogProductsDataSource } from '@app/types/dataSource/CatalogProductsDataSource'

export const getCatalogProductsDataFromResponse = (
  response?: ResponseDto<CatalogProductDto>
): CatalogProductsDataSource[] | undefined => {
  if (!response) return

  const rawData: CatalogProductDto[] | undefined = response.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id ?? null,
    code: dto.code ?? null,
    name: dto.name ?? null,
    trend: dto.subcategory?.purchasingGroup?.trend?.name ?? null,
    trendId: dto.subcategory?.purchasingGroup?.trend?.id ?? null,
    purchasingGroup: dto.subcategory?.purchasingGroup?.name ?? null,
    purchasingGroupId: dto.subcategory?.purchasingGroup?.id ?? null,
    commodityGroup: dto.subcategory?.category?.commodityGroup?.name ?? null,
    commodityGroupId: dto.subcategory?.category?.commodityGroup?.id ?? null,
    category: dto.subcategory?.category?.name ?? null,
    categoryId: dto.subcategory?.category?.id ?? null,
    subcategory: dto.subcategory?.name ?? null,
    subcategoryId: dto.subcategory?.id ?? null
  }))
}
